import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import TabComponent from '../../../../components/TabComponent/TabComponent';
import GroupData from './InfoGroup/GroupData/GroupData';
import Members from './InfoGroup/Members/Members';
import ServiceOffered from './InfoGroup/ServiceOffered/ServiceOffered';
import SupportGroup from './InfoGroup/SupportGroup/SupportGroup';
import ChatHistoryGroup from './InfoGroup/ChatHistoryGroup/ChatHistoryGroup';
import './DetailsGroup.css';
// Services
import { groupService } from '../../../../services/Group';

const DetailsGroup = () => {
  const [orgOptions, setOrgOptions] = useState([]);

  const { id } = useParams();
  const location = useLocation();
  const { group } = location.state || {};
  const [activeTab, setActiveTab] = useState('group-data');
  const [isEditing, setIsEditing] = useState(false);
  const [groupData, setGroupData] = useState({});
  const [tickets, setTickets] = useState([]);
  const [services, setServices] = useState([]);

  useEffect(() => {
    if (id) {
      fetchGroupData(id);
      fetchGroupDetails(id);
    }
    fetchOrganizations();
  }, [id]);

  const fetchGroupData = async (id) => {
    try {
      const response = await groupService.dataGroup(id);
      console.log('groupData', response);
      if (response) {
        setGroupData(response);
      }
    } catch (error) {
      console.error('Error fetching group data:', error);
    }
  };

  const fetchGroupDetails = async (id) => {
    try {
      const response = await groupService.groupdetail(id);
      console.log('groupData', response);
      if (response) {
        setTickets(response.support_tickets);
        setServices(response.services);
      }
    } catch (error) {
      console.error('Error fetching group data:', error);
    }
  };

  const fetchOrganizations = async () => {
    try {
      const response = await groupService.getOrganizations();
      const opts = (response || []).map(o => ({ value: String(o.id), label: o.name }));
      setOrgOptions(opts);
    } catch (e) {
      console.error('Error fetching orgs', e);
    }
  };

  const handleEdit = () => {
    if (isEditing) {
      // Aquí iría la lógica para guardar los cambios
      setIsEditing(false);
    } else {
      setIsEditing(true);
    }
  };

  const tabs = [
    { id: 'group-data', label: 'Group data' },
    { id: 'members', label: 'Members' },
    { id: 'services', label: 'Services offered' },
    { id: 'chat', label: 'Chat history' },
    { id: 'support', label: 'Support' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'group-data':
        return (
          <GroupData
            groupData={groupData}
            group={group}
            orgOptions={orgOptions}
          />
        );
      case 'members':
        return <Members groupId={groupData.id} />;
      case 'services':
        return <ServiceOffered groupId={groupData.id} services={services} />;
      case 'chat':
        return <ChatHistoryGroup groupId={groupData.id} />;
      case 'support':
        return <SupportGroup tickets={tickets} />;
      default:
        return null;
    }
  };

  return (
    <div className="details-group-page">
      <div className="details-group-container">
        <TabComponent
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        >
          {renderTabContent()}
        </TabComponent>
      </div>
    </div>
  );
};

export default DetailsGroup;